namespace GeniuzPOS.AdvPromo {
    export namespace LookupAvPromoCouponTypesService {
        export const baseUrl = 'AdvPromo/LookupAvPromoCouponTypes';

        export declare function Create(request: Serenity.SaveRequest<LookupAvPromoCouponTypesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<LookupAvPromoCouponTypesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<LookupAvPromoCouponTypesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LookupAvPromoCouponTypesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/LookupAvPromoCouponTypes/Create",
            Update = "AdvPromo/LookupAvPromoCouponTypes/Update",
            Delete = "AdvPromo/LookupAvPromoCouponTypes/Delete",
            Retrieve = "AdvPromo/LookupAvPromoCouponTypes/Retrieve",
            List = "AdvPromo/LookupAvPromoCouponTypes/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>LookupAvPromoCouponTypesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
